package com.ijoin.payment

import com.ijoin.i18n.SupportedLanguages

data class StripeOverlayCopy(
    val title: String,
    val description: String,
    val payButton: String,
    val payButtonLoading: String,
    val cancelButton: String,
    val openError: String,
    val cancelMessage: String,
    val initError: String,
    val paymentFailed: String,
    val unexpectedStatusPrefix: String,
    val processingFailed: String,
) {
    fun unexpectedStatus(status: String): String = "$unexpectedStatusPrefix$status"
}

fun stripeOverlayCopy(locale: String): StripeOverlayCopy {
    val strings = SupportedLanguages.fromCode(locale).strings
    return StripeOverlayCopy(
        title = strings.paymentStripeOverlayTitle,
        description = strings.paymentStripeOverlayDescription,
        payButton = strings.paymentStripeOverlayPayButton,
        payButtonLoading = strings.paymentStripeOverlayPayButtonLoading,
        cancelButton = strings.paymentStripeOverlayCancelButton,
        openError = strings.paymentStripeOverlayOpenError,
        cancelMessage = strings.paymentStripeOverlayCancelMessage,
        initError = strings.paymentStripeOverlayInitError,
        paymentFailed = strings.paymentStripeOverlayPaymentFailed,
        unexpectedStatusPrefix = strings.paymentStripeOverlayUnexpectedStatusPrefix,
        processingFailed = strings.paymentStripeOverlayProcessingFailed,
    )
}
